<template>
    <div class="rule-dialog">
      <b-modal
        id="modalViewer"
        modal-class="no-header custom-dialog dialog-1200"
        ok-only
        no-close-on-esc
        no-close-on-backdrop
        centered
        no-footer>
        <div>
          <div class="close-modal" v-if="!!isAdmin">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="finish"
              >
                <feather-icon
                  icon="XIcon"
                  size="20"
                />
              </b-button>
          </div>
          <div class="scrollable-notification">
            <div class="mb-1" v-if="!!isAdmin">
              <span v-if="displayedNotification.country.code == 'all'">
                <img class="styles-flags mr-50" :key="countries.id" v-for="countries in optionsCountries" style="margin-right: 0;" :src="require(`@/assets/images/flags/${countries.code.toLowerCase()}.png`)" :alt="countries.text">
              </span>
              <img class="styles-flags" style="margin-right: 0;" v-if="displayedNotification.country.code !== 'all'" :src="require(`@/assets/images/flags/${displayedNotification.country.code.toLowerCase()}.png`)" :alt="displayedNotification.country.text">
            </div>
            <div v-if="displayedNotification.category" class="mb-3">
              <span>
                <b-badge pill :class="`badge-pop-up-${displayedNotification.category.color}`" class="personalize-badge-pop-up">
                  <span>{{ displayedNotification.category.text }}</span>
                </b-badge>
              </span>
            </div>
            <div
              v-if="displayedNotification.type_communication && displayedNotification.type_communication.id === 'standard'"
              class="d-flex justify-content-between mt-1 mb-3 align-items-center"
            >
               <div class="title-notification">
                  <h2><strong>{{ displayedNotification.title_support }}</strong></h2>
                  <h1><strong>{{ displayedNotification.title }}</strong></h1>
               </div>
               <div>
                  <img
                    :src="getNotificationLogoAndAlt(displayedNotification, true).logo"
                    :alt="getNotificationLogoAndAlt(displayedNotification, true).alt"
                    width="230"
                  />
               </div>
            </div>
            <div v-if="displayedNotification && displayedNotification.content" v-html="displayedNotification.content"></div>
          </div>
        </div>
        <template #modal-footer="">
          <div class="actions-btn">
            <b-button @click="prev" v-if="showPrev" variant="outline-primary" class="mr-10 prev float-mobile-left prev-button">
              <feather-icon
                icon="ChevronLeftIcon"
                size="16"
              /> Atrás
            </b-button>
            <div class="notification-indicators center-button-all-close-notifications" v-if="notifications.length > 1">
              <span
                v-for="notification in notifications.slice(0, 4)"
                :key="notification.id"
                :class="{'active': notification.id === displayedNotification.id}"
                class="notification-circle">
              </span>
              <span
                v-if="notifications.length > 4"
                :class="{
                  'active': displayedNotificationIndex >= 4
                }"
                class="notification-circle last-circle">
              </span>
            </div>
            <b-button @click="finish" v-if="showClose" variant="success" class="close-notification" :class="onlyClose ? 'center-button-all-close-modal' : 'push-right float-mobile-left'">Entendido</b-button>
            <b-button @click="next" v-if="showNext" variant="success" class="push-right float-mobile-left d-flex align-items-center">Siguiente &nbsp;
              <feather-icon
                icon="ChevronRightIcon"
                size="16"
                stroke-width="3"
              />
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
</template>
<script>
export default {
  name: 'modal-view',
  props: ['displayedNotification', 'isAdmin', 'showClose', 'showNext', 'showPrev', 'showCloseAdmin', 'optionsCountries', 'notifications', 'onlyClose', 'getNotificationLogoAndAlt'],
  data () {
    return {

    }
  },
  methods: {
    next() {
      this.$emit('next')
    },
    prev() {
      this.$emit('prev')
    },
    finish() {
      this.$emit('finish')
    }
  }
}
</script>
<style lang="scss">
.actions-btn {
  position: relative;
  bottom:0;
  left:0;
  width: 100%;
}
.center-button-all-close-modal {
  display: block;
  margin: 0 auto;
  transform: translateX(10px);
}
.center-button-all-close-notifications {
  position: absolute;
  right: 43%;
  top: 15px;
}
#modalViewer .modal-footer {
  border: none;
  padding-bottom: 2rem;
}
.scrollable-notification {
  height: 480px;
  max-height: calc(100vh - 100px);
  max-width: calc(100vw - 5%);
  overflow: scroll;
  img {
    max-width: calc(100vw - 5%);
  }
}
.scrollable-notification::-webkit-scrollbar {
  -webkit-appearance: none;
}
.scrollable-notification::-webkit-scrollbar:vertical {
  width: 11px;
}
.scrollable-notification::-webkit-scrollbar:horizontal {
  height: 11px;
}
.scrollable-notification::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, .5);
}
.scrollable-notification::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
.close-modal{
  display: flex;
  justify-content: end;
}
.close-modal button {
  border: none !important;
  color: #00000078;
  padding: 1rem 0;
}
.close-modal button:hover {
  background: transparent !important;
  color: #00000078 !important;
}
.personalize-badge-pop-up{
  padding: 0.5rem 0.7rem;
}
.badge-pop-up-warning {
  background: #f1870541;
}
.badge-pop-up-warning span {
  color: #F18805;
}
.badge-pop-up-success {
  background: #1f9d5842;
}
.badge-pop-up-success span {
  color: #1f9d57;
}
.badge-pop-up-info {
  background: #00d1e841;
}
.badge-pop-up-info span {
  color: #00cfe8;
}
.prev-button {
  padding: 0.786rem 0;
  border: none !important;
  color: #1967D2;
}
.prev-button:hover {
  background: transparent !important;
  color: #1967D2;
}
.notification-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
}

.notification-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 5px;
  border: 1px solid #1967D2;
}

.notification-circle.active {
  background-color: #1967D2;
}
.title-notification h1 {
  font-size: 30px;
  color: #282828;
}
.title-notification h2 {
  font-size: 20px;
  color: #282828;
}
</style>
